module.exports = __webpack_public_path__ + "img/intro_300x300_cover.82741455.jpg";